import { createContext } from 'react';

import { NONE_ROLE, RolesContextType } from './RolesContext.types';

const initialContext: RolesContextType = {
  getRoleInAccount: () => NONE_ROLE,
  roles: [],
};

export const RolesContext = createContext(initialContext);
